import "./ProfileAddToHomescreen.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileAddToHomescreenComponentController from "./ProfileAddToHomescreenComponentController";

export default class ProfileAddToHomescreenComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = ProfileAddToHomescreenComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/AddToHomescreen/ProfileAddToHomescreen.html";
    }
}

module("mmAuth").component("mmProfileAddToHomescreen", new ProfileAddToHomescreenComponent());
